// extracted by mini-css-extract-plugin
export default {"warningContainer":"Warning_warningContainer__p84jj"};